import CommonLayout from './CommonLayout';

export default CommonLayout;
